import { checkPermission } from "library/authorization/index.mjs"

export function hasAnyDemand(demand) {
    return checkPermission(demand, false)
}
